export default "__VITE_ASSET__8ytmwNQz__"